import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

import { RegFormContextType } from "../../type";
import { Base64Util } from "shared/utils/base64";
import QueryParamKey from "shared/enums/QueryParamKey";
import { useRegDetail } from "shared/context/regDetail";
import { RegistrationRoute } from "apps/registration/routes/route";

export function useInvoicePayerRegPaymentService() {
  const { transactionDetails, refetchInvoicePaymentRequest } = useOutletContext<RegFormContextType>();
  const navigate = useNavigate();
  const regDetails = useRegDetail();

  const navigateToConfirmation = React.useCallback(
    (regParticipantId, invoicePaymentRequestId) => {
      const encodedInvoicePayerId = Base64Util.encode(regParticipantId);
      const encodedInvoicePaymentRequestId = Base64Util.encode(invoicePaymentRequestId);
      navigate(
        {
          pathname: RegistrationRoute.InvoicePayerConfirmation,
          search: `?${QueryParamKey.INVOICE_PAYER_ID}=${encodedInvoicePayerId}&${QueryParamKey.INVOICE_PAYMENT_REQUEST_ID}=${encodedInvoicePaymentRequestId}`
        },
        { replace: true }
      );
    },
    [navigate]
  );

  const paymentSuccessHandler = React.useCallback(() => {
    refetchInvoicePaymentRequest();
    navigateToConfirmation(transactionDetails.invoicePayerId, transactionDetails.invoicePaymentRequestId);
  }, [
    navigateToConfirmation,
    refetchInvoicePaymentRequest,
    transactionDetails.invoicePayerId,
    transactionDetails.invoicePaymentRequestId
  ]);

  return {
    regDetails,
    transactionDetails,
    paymentSuccessHandler,
    refetchInvoicePaymentRequest
  };
}
